'use client';
import Typography from '@egalite/ui/Typography';
import Link from 'next/link';
import { FC } from 'react';
import YouTube from 'react-youtube';
import ReactMarkdown from 'react-markdown'

type SponsorPageData = {
	data: {
		logo?: string;
		name?: string;
		color?: string;
		description?: string;
		video?: string;
	};
};

const Hero: FC<SponsorPageData> = ({ data = {} }) => {
	const { logo, name, color, video, description } = data;
	// const description = `# Para fazer um título grande\n\n## Para fazer um título médio\n\n### Para fazer um título pequeno\n\npara falhar uma linha, use duas quebras de linha\n\npara deixar um texto em **negrito**\n\npara fazer um [link](https://www.google.com)\n\n* para adicionar bullets\n\n* coloque um asterisco e um espaço antes do texto\n\n1. para uma lista ordenada\n\n2. coloque um número e um espaço antes do texto`

	if (name == null || name == '') {
		return (
			<div className="container flex flex-col items-center justify-center py-48">
				<Typography variant="headline-3" asEl="h1">
					Patrocinador não encontrado.
				</Typography>
				<Link href="/" className="text-brand-main">
					<Typography variant="body-1">Voltar para o início</Typography>
				</Link>
			</div>
		);
	}
	return (
		<div className="container">
			{/* @ts-ignore  */}
			<div style={{ '--bg-color': color }} className="h-48 w-full rounded-4xl bg-[var(--bg-color)] mt-24"></div>
			<div className="flex flex-col md:flex-row items-start justify-between gap-8">
				<div className="h-72 w-72 bg-white rounded-2xl p-4 flex grow-0 shrink-0 items-center justify-center ml-8 -mt-24 shadow">
					<img src={logo} alt={name} />
				</div>
				<div className='grow'>
					<Typography variant="h1" className="mt-12 mb-24">
						{name}
					</Typography>
					<Typography variant="sub-headline-1" className="mb-12">
						Sobre a empresa
					</Typography>
					{description ? (
							<ReactMarkdown className="mb-24 text-lg leading-normal markdown-css">
								{description}
							</ReactMarkdown>
					) : null}
					{/* <Typography variant="body-2" className="text-[gray] mb-40" dangerouslySetInnerHTML={{ __html: description.replace(/\n\n/g, '<br /><br />') }}>
					</Typography> */}
					{video ? (
						<YouTube
							videoId={video}
							className="relative w-full pt-[56%] mb-24"
							iframeClassName="absolute w-full h-full top-0 left-0"
						/>
					) : null}
				</div>
			</div>
		</div>
	);
};

export default Hero;
